import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Leaf, Menu, X } from 'lucide-react';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/our-process', label: 'Our Process' },
    { path: '/why-boai', label: 'Why BoAI' },
    { path: '/ai-solutions', label: 'AI Solutions' },
    { path: '/climate', label: 'Climate' },
    { path: '/farm-insights-info', label: 'Farm Insights' },
    { path: '/community-info', label: 'Community' },
    { path: '/marketplace-info', label: 'Marketplace' },
  ];

  return (
    <nav className="site-navbar" data-testid="main-navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <Leaf size={22} />
          <span>BoAI</span>
        </Link>

        <div className={`navbar-links ${mobileOpen ? 'open' : ''}`}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`navbar-link ${location.pathname === link.path ? 'active' : ''}`}
              onClick={() => setMobileOpen(false)}
              data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/auth"
            className="navbar-cta"
            onClick={() => setMobileOpen(false)}
            data-testid="nav-login"
          >
            Login / Sign Up
          </Link>
        </div>

        <button
          className="navbar-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
          data-testid="navbar-toggle"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
